<app-page-header [heading]="'Statement of Account Supplier'" [icon]="'fa-list'" style="height:100px;"></app-page-header>

<div *ngIf="user_rights.ADD == '1'" class="page-panel">
    <div class="row mb-3 mt-4">
        <div class="form-group col-md-6">
            <label>Supplier Name</label><span class="text-danger">&nbsp;*</span>
            <ngx-select-dropdown
                    (change)="getVendor($event);"
                    [(ngModel)]="vendor_data"
                    [config]="utils.dropConfig({displayKey: 'VENDOR_NAME',placeholder: 'Select supplier',searchOnKey: 'VENDOR_NAME'})"
                    [multiple]="false"
                    [options]="vendor_options" class="form-control select-dropdown" name="vendor_data">
            </ngx-select-dropdown>
        </div>
        <div class="col-md-3 mt-4 d-flex align-items-center button-group">
            <button class="btn btn-primary" (click)="fetchSOA()">
                <i class="fas fa-search me-2"></i> View SOA
            </button>
            <button class="btn btn-danger" (click)="downloadPDF()">
                <i class="fas fa-file-pdf me-2"></i> Download PDF
            </button>
        </div>
    </div>

    <table class="table table-bordered align-middle">
        <thead class="table-secondary text-center">
        <tr>
            <th colspan="3">Invoice</th>
            <th colspan="3">Receipt</th>
        </tr>
        <tr>
            <th class="text-center">Date</th>
            <th class="text-center">Invoice No</th>
            <th class="text-right">Amount</th>
            <th class="text-center">Date</th>
            <th class="text-center">Receipt No</th>
            <th class="text-right">Amount</th>
        </tr>
        </thead>

        <tbody>
        <tr *ngFor="let row of invoiceList; let i = index">
            <td class="text-center">{{ row.invoice_date || '-' }}</td>
            <td class="text-center">{{ row.invoice_no || '-' }}</td>
            <td class="text-right">{{ row.invoice_amt | number: '1.2-2' }}</td>
            <td class="text-center">{{ row.receipt_date || '-' }}</td>
            <td class="text-center">{{ row.receipt_no || '-' }}</td>
            <td class="text-right">{{ row.receipt_amt | number: '1.2-2' }}</td>
        </tr>

        <tr class="fw-bold table-light">
            <td colspan="2" class="text-end"><strong>Total Invoice</strong></td>
            <td class="text-right"><strong>{{ totalInvoiceAmount | number: '1.2-2' }}</strong></td>
            <td colspan="2" class="text-end"><strong>Total Receipt</strong></td>
            <td class="text-right"><strong>{{ totalReceiptTotal | number: '1.2-2' }}</strong></td>
        </tr>
        </tbody>
    </table>

    <div class="text-end mt-3">
        <strong>
            Balance Receipt Due ({{ totalInvoiceAmount | number: '1.2-2' }} -
            {{ totalReceiptTotal | number: '1.2-2' }}) =
            {{ totalBalance | number: '1.2-2' }}
        </strong>
    </div>
</div>
